import {
    CreatePublicApiKeyAction,
    ClearApiKeyAction,
    CREATE_PUBLIC_API_KEY,
    CLEAR_API_KEY,
} from '../actions/publicApi';

export interface ApiKey {
    keyValue: string;
}

export type PublicApiActionTypes = CreatePublicApiKeyAction | ClearApiKeyAction;

const publicApiKey: (state: ApiKey, action: PublicApiActionTypes) => ApiKey = (state = { keyValue: null }, action) => {
    switch (action.type) {
        case CREATE_PUBLIC_API_KEY:
            return {
                ...state,
                keyValue: action.payload.keyValue,
            };
        case CLEAR_API_KEY:
            return { ...state, keyValue: null };
        default:
            return state;
    }
};

export default publicApiKey;
